import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CheckCircle2Icon, ZapIcon, TargetIcon, EyeIcon } from 'lucide-react';
export function SolutionSection() {
  const features = [{
    icon: <TargetIcon className="w-6 h-6 text-primary" data-id="element-204" />,
    title: 'Músculos Implicados',
    desc: 'Agonistas, sinergistas y estabilizadores detallados.'
  }, {
    icon: <ZapIcon className="w-6 h-6 text-primary" data-id="element-205" />,
    title: 'Movimientos Articulares',
    desc: 'Análisis biomecánico para una ejecución perfecta.'
  }, {
    icon: <EyeIcon className="w-6 h-6 text-primary" data-id="element-206" />,
    title: 'Errores Frecuentes',
    desc: 'Identificá y corregí fallos antes de que ocurran.'
  }];
  return <section className="py-24 relative overflow-hidden" data-id="element-207">
      {/* Background elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" data-id="element-208" />
      <div className="absolute bottom-0 left-0 w-[600px] h-[600px] bg-secondary/5 rounded-full blur-[100px] pointer-events-none" data-id="element-209" />

      <div className="container mx-auto px-4 max-w-5xl relative z-10" data-id="element-210">
        <FadeIn className="text-center mb-16" data-id="element-211">
          <span className="text-primary font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-212">
            El Mecanismo Único
          </span>
          <h2 className="text-4xl md:text-5xl font-black mb-6" data-id="element-213">
            La Base Técnica de{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-214">
              140 Ejercicios
            </span>{' '}
            Analizados
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed" data-id="element-215">
            No es solo una colección de ejercicios. Es un sistema organizado,
            con cada ejercicio desglosado: músculos implicados (agonistas,
            sinergistas, estabilizadores), movimientos articulares, ejecución
            correcta, errores frecuentes e ilustraciones. Así, podés responder
            con total seguridad cada vez que alguien te pregunte:{' '}
            <strong className="text-white font-semibold" data-id="element-216">
              "¿Por qué este ejercicio?"
            </strong>
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-217">
          {features.map((feature, index) => <FadeIn key={index} delay={0.2 + index * 0.1} direction="up" data-id="element-218">
              <div className="bg-card border border-card-border rounded-2xl p-8 h-full hover:border-primary/50 transition-colors group" data-id="element-219">
                <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform" data-id="element-220">
                  {feature.icon}
                </div>
                <h3 className="text-xl font-bold mb-3 text-white" data-id="element-221">
                  {feature.title}
                </h3>
                <p className="text-gray-400" data-id="element-222">{feature.desc}</p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-223">
          <div className="bg-gradient-to-r from-card to-background border border-primary/20 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-12 shadow-2xl shadow-primary/5" data-id="element-224">
            <div className="flex-1" data-id="element-225">
              <h3 className="text-2xl font-bold mb-4" data-id="element-226">
                Cada ejercicio está desglosado visualmente
              </h3>
              <p className="text-gray-400 mb-6" data-id="element-227">
                Incluye ilustraciones claras y ejecución correcta paso a paso.
                Un recurso diseñado específicamente para consulta rápida en el
                gimnasio o antes de tus clases.
              </p>
              <ul className="space-y-3" data-id="element-228">
                {['Ilustraciones anatómicas claras', 'Checklists de ejecución rápida', 'Formato digital accesible 24/7'].map((item, i) => <li key={i} className="flex items-center gap-3 text-gray-300" data-id="element-229">
                    <CheckCircle2Icon className="w-5 h-5 text-green-500 shrink-0" data-id="element-230" />
                    <span data-id="element-231">{item}</span>
                  </li>)}
              </ul>
            </div>
            <div className="w-full lg:w-1/2 shrink-0 relative h-[300px] sm:h-[400px]" data-id="element-232">
              <img src="https://cdn.magicpatterns.com/uploads/9n6SepfnQw1QdTcvQsNKrt/imagen_1.png" alt="Muestra del interior - Funciones Musculares" className="absolute left-0 top-0 w-2/3 rounded-xl shadow-2xl transform -rotate-6 hover:rotate-0 transition-transform duration-500 z-10 border border-card-border" data-id="element-233" />
              <img src="https://cdn.magicpatterns.com/uploads/abuG45Vn56HQWF8J6uWfTi/imagen_2.png" alt="Muestra del interior - Sentadilla Frontal" className="absolute right-0 bottom-0 w-2/3 rounded-xl shadow-2xl transform rotate-6 hover:rotate-0 transition-transform duration-500 z-20 border border-card-border" data-id="element-234" />
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}